import { defineStore } from "pinia"


export const useLeadsStore = defineStore("leads", {
    state: () => {
        return {
            leads: [],
        }
        
    },
    actions: {
        
    }
})